import "../../../../styles/page/order.scss";
import "../../../../styles/page/order.scss";

import ClaimCart from "./ClaimCart.jsx";
import ClaimProductPage from "./ClaimProductPage.jsx";
import { Localization } from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import { scssVariables } from "../../../common/util/config";

class HistoryClaimPage extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            view: this.props.startView,
        };

        this.onClickSwapPage = this.onClickSwapPage.bind(this);
        this.calculateShoppingCartHeight = this.calculateShoppingCartHeight.bind(this);
    }

    UNSAFE_componentWillMount() {
        const {
            prepareQueryOptions,
        } = this.props;

        prepareQueryOptions();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if( this.state.view !== nextProps.startView) {
            this.setState({
                view: !nextProps.startView || nextProps.startView==="" ? "invoice" : nextProps.startView,
            });
        }
    }

    onClickSwapPage(event, view) {
        this.props.history.push(`/history/claim/${this.props.invoiceId}/${view?view:""}`);
    }

    calculateShoppingCartHeight() {
        const {
            deviceType,
            height,
        } = this.props;
        let productDisplayHeight = height;
        
        //page padding
        productDisplayHeight -= parseInt(scssVariables[`${deviceType}ContentPadding`])*2;
        //product display margin
        productDisplayHeight -= parseInt(scssVariables.cardMargin)*2;

        return productDisplayHeight;
    }

    render(){
        const {
            clearQuery,
            deviceType,
            localization,
            invoiceLines,
            setOrderProductView,
            productView,
            addRemoveSalesUnitToClaim,
            addRemoveWarehouseUnitToClaim,
            clearClaim,
            editClaim,
            editClaimItem,
            editQueryFilter,
            height,
            width,
            loadMoreSearchedProducts,
            productQuery,
            deliveryDates,
            productLists,
            editingList,
            flowControl,
            listId,
            setModal,
            setDropDown,
            commitInvoiceClaim,
            invoiceId,
            historyFilter,
        } = this.props;
        const shoppingCartHeight = this.calculateShoppingCartHeight();
        return (
            <ClaimProductPage
                clearQuery={clearQuery}
                deviceType={deviceType}
                localization={localization}
                setOrderProductView={setOrderProductView}
                productView={productView}
                activeList={editingList}
                invoiceLines={invoiceLines}
                invoiceId={invoiceId}
                addRemoveSalesUnitToClaim={addRemoveSalesUnitToClaim}
                addRemoveWarehouseUnitToClaim={addRemoveWarehouseUnitToClaim}
                editQueryFilter={editQueryFilter}
                filter={{
                    OnlyCampaigns: false,
                    OnlyNews: false,
                    OnlyLastSold: false,
                    ReturnTobacco: false,
                    ProductGroupId: null,
                    SupplierId: null,
                    SortingColumn: null,
                }}
                historyFilter = {historyFilter}
                height={height}
                width={width}
                loadMoreSearchedProducts={loadMoreSearchedProducts}
                productQuery={productQuery}
                productLists={productLists}
                onClickShowProducts={this.onClickSwapPage}
                currentView={this.state.view}
                flowControl={flowControl}
                setModal={setModal}
                setDropDown={setDropDown}
                titleTabs={undefined}
                cart={<ClaimCart
                    localization={localization}
                    height={shoppingCartHeight}
                    width={width}
                    deviceType={deviceType}
                    editingList={editingList}
                    productLists={productLists}
                    addRemoveSalesUnitToClaim={addRemoveSalesUnitToClaim}
                    addRemoveWarehouseUnitToClaim={addRemoveWarehouseUnitToClaim}
                    editClaim={editClaim}
                    editClaimItem={editClaimItem}
                    deliveryDates={deliveryDates}
                    listId={listId}
                    setModal={setModal}
                    setDropDown={setDropDown}
                    commitInvoiceClaim={commitInvoiceClaim}
                    clearClaim={clearClaim}
                />}
            />
        );
    }
}

HistoryClaimPage.propTypes = {
    //Required
    clearQuery: PropTypes.func.isRequired,
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    invoiceId: PropTypes.number.isRequired,
    invoiceLines: PropTypes.array.isRequired,
    setOrderProductView: PropTypes.func.isRequired,
    productView: PropTypes.object.isRequired,
    addRemoveSalesUnitToClaim: PropTypes.func.isRequired,
    addRemoveWarehouseUnitToClaim: PropTypes.func.isRequired,
    editClaim: PropTypes.func.isRequired,
    editClaimItem: PropTypes.func.isRequired,
    editQueryFilter: PropTypes.func.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    loadMoreSearchedProducts: PropTypes.func.isRequired,
    productQuery: PropTypes.object.isRequired,
    prepareQueryOptions: PropTypes.func.isRequired,
    deliveryDates: PropTypes.array.isRequired,
    productLists: PropTypes.object.isRequired,
    editingList: PropTypes.object.isRequired,
    startView: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    getInvoiceDetails: PropTypes.func.isRequired,
    flowControl: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    commitInvoiceClaim: PropTypes.func.isRequired,
    clearClaim: PropTypes.func.isRequired,
    //
    listId: PropTypes.number,
    //What filter should be used
    filter: PropTypes.object,
    historyFilter: PropTypes.object,
};

export default HistoryClaimPage;